import {loadedImagesEventHook} from "./images";

class NewsletterKlaviyo extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.klaviyoListId = this.getAttribute('data-klaviyo-list-id');
    this.email = this.querySelector('input[type="email"]');

    if (this.klaviyoListId) {
      this.form.addEventListener('submit', this.sendForm.bind(this));
    } else {
      return console.error('Klaviyo form id not found.');
    }

    console.log(this.form)
  }
  formData() {
    return {
      g: this.klaviyoListId,
      '$fields': '$source,$email,$name,$consent_method,$consent_form_id',
      '$list_fields' : '',
      '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
      '$source': 'Newsletter',
      '$email': (this.querySelector('input[type="email"]')) ? this.querySelector('input[type="email"]').value : '',
      '$name': (this.querySelector('input[type="text"]')) ? this.querySelector('input[type="text"]').value : '',
      '$consent_method': 'Klaviyo Form',
      '$origin': 'origin'
    };
  }
  showMessage(type) {
    this.email.classList.add(type);
    this.querySelector('.newsletter__message-klaviyo--' + type).classList.remove('hidden');

    setTimeout(() => {
      this.email.classList.remove(type);
      this.querySelector('.newsletter__message-klaviyo--' + type).classList.add('hidden');
    }, 6000)
  }
  sendForm(event) {
    event.preventDefault();
    const _this = this;
    if (this.emailValidation()) {
      fetch("https://a.klaviyo.com/ajax/subscriptions/subscribe", {
        "headers": {
          "accept": "*/*",
          "accept-language": "en-US,en;q=0.9",
          "content-type": "application/x-www-form-urlencoded",
        },
        "body": _this.objToStrUrlEncode(_this.formData()),
        "method": "POST",
        "mode": "cors",
        "credentials": "omit"
      }).then(response => response.json())
        .then(response => {
          console.log(response)
          if (response.success) {
            (response.data.is_subscribed) ? _this.showMessage("is-subscribed") : _this.showMessage("success");
          } else {
            _this.showMessage("error");
          }
        })
        .catch(err => {
          console.log(err)
          _this.showMessage("error");
        });
    } else {
      this.showMessage("error-email");
    }
  }
  objToStrUrlEncode(obj) {
    const str = [];
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && typeof obj[key] !== "undefined") {
        str.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
      }
    }
    return str.join("&")
  }

  emailValidation() {
    if (this.email) {
      const emailValue = this.email.value;
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(emailValue);

      return result && result !== ''
    } else {
      return true
    }
  }
}
customElements.define("newsletter-klaviyo", NewsletterKlaviyo);
